module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				changePassword: fox.i18n.getTranslation('changePassword', 'Change Password', 'dialog'),
				fieldEmpty: fox.i18n.getTranslation('fieldEmpty', 'Field should not be empty', 'errors'),
				fieldsDoNotMatch: fox.i18n.getTranslation('fieldsDoNotMatch', 'New and confirmed passwords do not match', 'errors'),
				fieldIcorrectPass: fox.i18n.getTranslation('fieldIcorrectPass', 'Incorrect Password', 'errors'),
				congratulations: fox.i18n.getTranslation('congratulations', 'Congratulations', 'dialog'),
				passwordPreviousMatch: fox.i18n.getTranslation('passwordPreviousMatch', 'New password cannot match your 3 previous ones', 'errors'),
				needPickNewPass: fox.i18n.getTranslation('needPickNewPass', 'Oops! You need to pick a new password to proceed.', 'errors'),
				'passHasBeenUsedBeforeChooseUniquePass': fox.i18n.getTranslation('passHasBeenUsedBeforeChooseUniquePass', 'Oops! This password has been used before. Please choose a unique password to proceed.', 'error'),
				shortPassword: fox.i18n.getTranslation('shortPassword', 'Password should be at least 6 symbols', 'errors'),
			};
			
			return translation[alias] || '';
		}
	};

	fox.registerWidget('Popup_ChangePassword', {
		
		configure: function(options) {

			this.registerOptions('', {
				widgets: {
					api: {
						widget: 'Api',
						method: 'Site_Authorizer.changePassword',
						httpMethod: 'post'
					}
				},
				autoRender: true,
				container: '#popup-widget-container',
				template: 'popup_changePassword',
				handleDom: {
					cancel: {
						target: '#cancel-change-password',
						event: 'click',
						callback: 'cancel'
					},
					apply: {
						target: '#apply-change-password',
						event: 'click',
						callback: 'confirm'
					},
					handleInputsFocus: {
						target: '.fields2send',
						event: 'focus',
						callback: 'handleInputs'
					},
					handleInputsBlur: {
						target: '.fields2send',
						event: 'blur',
						callback: 'handleInputs'
					}					
				},

				'handleWom.api': {
					widget: '#api',
					event: ['success', 'failure'],
					callback: '@this:responseHandler'
				}
			});

			return this.callParent('configure', arguments);
		},
		
		running: function() {
			this.popup = this.getParent();
		},

		rendering: function () {
			this.callParent('rendering', arguments);
			this.fields = {};

			fox.each(fox.dom.select('.fields2send', this.fragment), function (field) {
				this.fields[field.name] = field;
			}, this);
		},

		handleInputs: function (el, alias, w, e) {
			//focus event
			if (e.type == 'focus') {
				this.hideError(el);

				return;
			}

			//blur event
			if (!el.value.length) {
				this.showError(el, _.getTranslation('fieldEmpty'));
				return;
			}

			if (el.value.length < 6) {
				this.showError(el, _.getTranslation('shortPassword'));
				return;
			}

			if (el.name == 'new' || el.name == 'confirm') {
				if ((this.fields['new'].value.length && this.fields['confirm'].value.length) && this.fields['new'].value != this.fields['confirm'].value) {
					this.showError(this.fields['confirm'], _.getTranslation('fieldsDoNotMatch'));
				}
			}
		},

		checkForSubmit: function () {
			this.changeSubmitState(this.checkFields());
		},

		changeSubmitState: function (state) {
			fox.dom[(state ? 'removeClass' : 'addClass')]('inactive', fox.dom.selectFirst('#apply-change-password', this.popup.element));
		},

		checkFields: function () {
			var result = true;
			var emptyFields = [];

			fox.each(this.fields, function (field) {
				if (!field.value.length) {
					emptyFields.push(field);
				}
			});

			if (emptyFields.length) {
				fox.each(emptyFields, function (field) {
					this.showError(field, _.getTranslation('fieldEmpty'));
				}, this);
				result = false;
			}

			if (this.fields['new'].value != this.fields['confirm'].value) {
				this.showError(this.fields['confirm'], _.getTranslation('fieldsDoNotMatch'));
			}


			return result;
		},

		cancel: function() {
			this.removeSpinner();
			this.popup.hide();
			this._indom = false;
		},

		confirm: function () {
			if (!this.checkFields()) {
				return;
			}

			var data = {};

			fox.each(this.fields, function (field) {
				var valuePass = encodeURIComponent(field.value);
				data[field.name] = (['new', 'old', 'confirm'].indexOf(field.name) !== -1) ? fox.trim(valuePass) : valuePass;
			});
			
			var but = $('#apply-change-password');
			but.addClass('spin');
			but.addClass('disabled');

			this.rwom1('#api').send(data); 
		},

		responseHandler: function (response, api, ev) {
			var answer = response.answer;
			var msg = '';
			var elm = this.fields.old;

			this.removeSpinner();

			if (ev === 'failure') {
				switch (answer.code) {
					case 111:
						msg = _.getTranslation('passwordPreviousMatch');
						elm = this.fields.new;
					break;
					case 113:
						msg = _.getTranslation('fieldIcorrectPass');
						elm = this.fields.old;
					break;
					case 40116:
					case 6031:
						msg = _.getTranslation('fieldsDoNotMatch');
						elm = this.fields.confirm;
					break;
					case 4032:
						msg = _.getTranslation('needPickNewPass');
						elm = this.fields.new;
					break;
					case 4033:
						msg = _.getTranslation('passHasBeenUsedBeforeChooseUniquePass');
						elm = this.fields.new;
					break;
					default:
						msg = answer.reason;
					break;
				}

				this.showError(elm, msg);

				return;
			}

			this.showSuccessMessage();
		},

		showSuccessMessage: function () {
			
			this.togglePopupChangePass('hide');

			window.setTimeout(fox.bind(function () {

				this.popup.hide();

				this.togglePopupChangePass('show');
								
			}, this), 1500);
		},

		togglePopupChangePass: function (state) {
			fox.dom.selectFirst('.popup-footer', this.popup.element).style.display = (state === 'hide' ? 'none' : 'block');
			fox.dom.selectFirst('.success-message', this.popup.element).style.display = (state === 'hide' ? 'block' : 'none');
			fox.dom.selectFirst('.rows', this.popup.element).style.display = (state === 'hide' ? 'none' : 'block');
			this.popup.dialog.dialog('option', 'width', (state === 'hide' ? 240 : 350))
			.dialog('option', 'title', (state === 'hide' ? _.getTranslation('congratulations') : _.getTranslation('changePassword')))
			.dialog('option', 'position', 'center')
			.dialog('option', 'dialogClass', (state === 'hide' ? 'dlg-amc dlg-amc-success' : 'dlg-amc'));
		},

		removeSpinner: function () {
			var but = $('#apply-change-password');
			but.removeClass('spin');
			but.removeClass('disabled');
		},

		showError: function (elem, msg) {
			msg || (msg = 'no message');

			if (!elem) {
				return;
			}

			var parent = elem.parentNode;
			var tooltip = fox.dom.selectFirst('.message', parent);

			tooltip.innerHTML = msg;

			fox.dom.removeClass('success', parent);
			fox.dom.addClass('error', parent);
		},

		hideError: function (elem) {
			var parent = elem.parentNode;
			var tooltip = fox.dom.selectFirst('.message', parent);

			tooltip.innerHTML = '';

			fox.dom.removeClass('error', parent);
		},

		showSuccess: function (elem) {
			fox.dom.addClass('success',  elem.parentNode);
		},

	});

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/popup/changePassword.js
// module id = 340
// module chunks = 2